// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors.808aa797be5b489a9a83.js";
	// return url for filenames based on template
	return "" + chunkId + ".chunk.bundle.js";
};